module.exports = __webpack_public_path__ + "static/media/HO14.8fe09f8d.png";